import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InfoCode } from 'src/app/models/domain';
import { InfoCodeAdapter } from 'src/app/models/domain/adapters';
import { InfocodesSetService, YPMINFOCODESSRVInfocodes } from 'src/generated-clients/infocodes';

@Injectable({
  providedIn: 'root',
})
export class InfoCodesDataService {
  private readonly materialNumberPropertyName: keyof YPMINFOCODESSRVInfocodes = 'materialNumber';

  public constructor(
    private readonly infoCodesSetService: InfocodesSetService,
    private readonly infoCodeAdapter: InfoCodeAdapter
  ) {}

  public getInfoCodesByDesignId(designId: string): Observable<InfoCode[]> {
    // materialNumber is designId in InfoCodes, it's not a mistake!
    const filter = `${this.materialNumberPropertyName} eq '${designId}'`;

    return this.infoCodesSetService.infocodesSetGet(undefined, undefined, filter).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d?.results) {
          throw new Error('SAP Error');
        }

        return res.d.results.map((infoCodes) => this.infoCodeAdapter.adaptToDomain(infoCodes));
      })
    );
  }
}
